import { render, staticRenderFns } from "./PcFileUploadDisabledScreen.vue?vue&type=template&id=255b3508&scoped=true&"
import script from "./PcFileUploadDisabledScreen.vue?vue&type=script&lang=js&"
export * from "./PcFileUploadDisabledScreen.vue?vue&type=script&lang=js&"
import style0 from "./PcFileUploadDisabledScreen.vue?vue&type=style&index=0&id=255b3508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255b3508",
  null
  
)

export default component.exports